import unique from 'unique-selector';
export default class Utils {
    constructor() {
    }
    async callAPI(token, method, api_url, data, is_byXHR, get_headers) {
      var myHeaders = new Headers();
      var requestOptions = {}
      let response = null
      let resp = null 

      try {
        if (token) {
          myHeaders.append("Authorization", 'Bearer ' + token);
        }
        myHeaders.append("Content-Type",  "application/json");
        
        requestOptions = {
          method: method,
          headers: myHeaders,
        };
        // console.error('call_api_error', api_url)
        let url = new URL(api_url)
        let container_id = url.searchParams.get('container_id')
        let platform = this.checkPlatform()
        if (platform === 'cyberbiz' && (!container_id || !container_id.includes('DV_'))) {
          let cb_id = await this.getCybMerchantId()
          url.searchParams.set('cyberbiz_shop_id', cb_id)
          url.searchParams.delete('container_id')
          url = url.href
        }

        if (data) {
          
          if (data.container_id && !data.container_id.includes('DV_')) {
            if (platform === 'cyberbiz') {
              let cb_id = ''
              cb_id = await this.getCybMerchantId()
              data["cyberbiz_shop_id"] = cb_id
              delete data['container_id']
            }
          }
          
          data['user_agent'] = window.navigator.userAgent
          data['event_timestamp'] = this.getYYYYMMDDHHMMSS('','-')
          requestOptions['body'] = JSON.stringify(data)
        }
        
        if (is_byXHR) {
          this.sendXHR(method, url, data)
        }
        else {
            response = await fetch(url, requestOptions)
            if (response.statusText !== 'No Content') {
                resp = await response.json()

                if (get_headers) {
                    resp.headers = response.headers
                }
            }
        }
        
      } catch (error) {
        console.error('call_api_error', error)
        console.error('call_api_error', api_url)
      }
      return resp
    }
    getNumbersFromString(str) {
      var numbers = str.match(/\d+/g);
      if (numbers) {
        return numbers.join('');
      }
      return '';
    }
    
    selectOptionByValue(select_ele, value) {
      var options = select_ele.options;
      for (var j = 0; j < options.length; j++) {
        if (options[j].value === value) {
          options[j].selected = true;
          break;
        }
      }
    }
    rgbToHex(rgb) {
      const values = rgb.match(/\d+/g).map(Number);
      const hexValues = values.map(value => {
        const hex = value.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
      });
      return "#" + hexValues.join("");
    }
    checkDevice(w){
      var screenWidth = window.screen.width
      if (window.innerWidth < screenWidth) {
        screenWidth = window.innerWidth
      }
      if (screenWidth < 768) {
        return 'mobile'
      } else if (screenWidth >= 768 && screenWidth < 1024) {
        return 'tablet'
      } else {
        return 'desktop'
      }
    }
    detectDeviceByWindowSize() {
      let width = window.screen.width;
      if (window.innerWidth < width) {
        width = window.innerWidth
      }
      if (width < 768) {
        return 'phone';
      } else if (width  >= 768 && width < 1024) {
        return 'pad';
      } else {
        return 'pc';
      }
    }
    getClidByContainerId(storage_key){

      let result = ''
      try {
        let container_storage = localStorage.getItem(storage_key)
        container_storage = JSON.parse(container_storage)
        if (container_storage) {
          result = container_storage['clid']
        }
      } catch (error) {
        result = ''
      }
      return result
    }

    getNumbersFromString(str) {
      // 使用正規表達式移除非數字字符
      return str.replace(/\D/g, "");
    }

    getYYYYMMDDHHMMSS(dateString, delimiter){
      // 建立新的 Date 物件
      let date = new Date();
      if (dateString) {
        date = new Date(dateString);
      }
      
      // 取得年份
      const year = date.getFullYear();
      
      // 取得月份
      let month = date.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      
      // 取得日期
      let day = date.getDate();
      day = day < 10 ? '0' + day : day;
      
      // 取得小時
      let hours = date.getHours();
      hours = hours < 10 ? '0' + hours : hours;
      
      // 取得分鐘
      let minutes = date.getMinutes();
      minutes = minutes < 10 ? '0' + minutes : minutes;
      
      // 取得秒數
      let seconds = date.getSeconds();
      seconds = seconds < 10 ? '0' + seconds : seconds;
      
      // 格式化日期和時間
      const formattedDateTime = `${year}${delimiter}${month}${delimiter}${day} ${hours}:${minutes}:${seconds}`;
      
      return formattedDateTime;
    }

    checkPlatform(){
      let platform = 'unknown'
      do {
          let is_shopline = document.querySelector("link[href*='shoplineapp.com']");
          if (is_shopline || window.app) {
              platform = 'shopline'
              break;
          }

          if (window.CYBERBIZ || window.cyb) {
              platform = 'cyberbiz' 
              break
          }

          let is_91app = window.nineyi
          if (is_91app) {
              platform = '91app' 
              break
          }

      }while(0)

      return platform
    }
    createDomByHtmlString(html_string) {
      var div = document.createElement('div');
      div.innerHTML = html_string.trim();
      return div.firstChild; 
    }

    setCookie(name, value, days) {
      var expires = '';
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        //date.setTime(date.getTime());
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + value + expires + '; path=/';
    }
    setNativeValue(element, value) {
      let lastValue = element.value;
      element.value = value;
      let event = new Event("input", { target: element, bubbles: true });
      // React 15
      event.simulated = true;
      // React 16
      let tracker = element._valueTracker;
      if (tracker) {
          tracker.setValue(lastValue);
      }
      element.dispatchEvent(event);
    }

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    sendXHR(method, api_url, payload){
      let data = null
      if (payload) {
        data = JSON.stringify(payload);
      }

      var xhr = new XMLHttpRequest();
      xhr.addEventListener("readystatechange", function() {
        if(this.readyState === 4) {
          console.log(this.responseText);
        }
      });
      
      xhr.open(method, api_url);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(data);
    }

    async getFile(url) {
      try {
          const response = await fetch(url, {
            method: 'GET',
          });
  
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
  
          return await response.text();
      } catch (error) {
          console.error('Error fetching file:', error);
          return null;
      }
    }

    recordError(payload){
      var data = JSON.stringify(payload);
      var xhr = new XMLHttpRequest();
      xhr.addEventListener("readystatechange", function() {
        if(this.readyState === 4) {
          console.log(this.responseText);
        }
      });
      
      xhr.open("POST", 'https://enterprise.nineder.com/flows/trigger/c234e797-e690-42a8-a388-606578258739');
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(data);
    }

    getRandomNumber(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    getUUID() {
      var d = Date.now();
      if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
        d += performance.now(); //use high-precision timer if available
      }
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    }

    extractNumbers(str) {
      return str.match(/\d+/g).map(Number);
    }
  

    getShoplineUserData() {

      var angular_params = window.app._invokeQueue;
      var angular_params_len = window.app._invokeQueue.length - 1;
      var user = null
      let data = null

      for(var idx = 0; idx < angular_params_len; idx++) {
        if(!angular_params[idx][2] || !angular_params[idx][2][0] || typeof(angular_params[idx][2][0]) === 'undefined') {
          continue;
        }
        if(angular_params[idx][2][0] !== 'mainConfig') {
          continue;
        }
        var config = angular_params[idx][2][1];
        if(config['currentUser'] === null || config['currentUser'] === undefined) {
          break;
        }
        user = config['currentUser']
      }

      if (user) {
        console.log('user',user)
        data = {}
        data['id'] = user['_id']
        data['email'] = user.email
        data['name'] = user.name
      }

      return data
    }

    getCyberbizUserData(){
      let user = null
      let data = null
      if (window.store) {
        user = JSON.parse(JSON.stringify(window.store.get('customer')))
      }

      if (user.id) {
        data = {}
        data['id'] = user.id
        data['email'] = user.email
        data['name'] = user.name
      }
      
      return data
      
    }

    async get91AppUserData(){

      let getUserData = async function() {
        var requestOptions = {
          method: 'GET',
          redirect: 'follow'
        };
        let result = {}
        try {
          let api = `${window.location.protocol}//${window.location.hostname}/webapi/VIPMember/GetVipInfo?isBinding=false&lang=zh-TW&shopId=${window.nineyi.shopId}`
          const response = await fetch(api, requestOptions);
          result = await response.json();
          console.log(result);
        } catch (error) {
          console.log('error', error);
        }
        return result
      };

      let getUserData2 = async function(card_id) {
        var requestOptions = {
          method: 'GET',
          redirect: 'follow'
        };
        let result = {}
        try {
          let api = `${window.location.protocol}//${window.location.hostname}/webapi/VIPMember/GetVIPMemberItemV2?memberCardId=${card_id}&lang=zh-TW&shopId=${window.nineyi.shopId}`
          const response = await fetch(api, requestOptions);
          result = await response.json();
          console.log(result);
        } catch (error) {
          console.log('error', error);
        }
        return result
      };
      
      let user_data = await getUserData();
      if (!user_data.Data) {
        return null
      }

      let card_id = user_data.Data.VipShopMemberCard.Id

      let detail_data = await getUserData2(card_id); 
      if (!detail_data.Data) {
        return null
      }

      let email = detail_data.Data.Member.find((column) => {
        return column.ColumnName === 'Email'
      })
      // let first_name = detail_data.Data.Member.find((column) => {
      //   return column.ColumnName === 'FirstName'
      // })
      // let last_name = detail_data.Data.Member.find((column) => {
      //   return column.ColumnName === 'LastName'
      // })

      let data = {
        id: user_data.Data.MemberCode,
        email: email.Value,
        name: user_data.Data.VipMemberInfo.FullName
      }

      return data
    }

    getShoplineMerchantId(){
      var angular_params = window.app._invokeQueue;
      var angular_params_len = window.app._invokeQueue.length - 1;
      let data = null
      let shop_id = ''

      for(var idx = 0; idx < angular_params_len; idx++) {
        if(!angular_params[idx][2] || !angular_params[idx][2][0] || typeof(angular_params[idx][2][0]) === 'undefined') {
          continue;
        }
        if(angular_params[idx][2][0] !== 'mainConfig') {
          continue;
        }
        data = angular_params[idx][2][1];
      }

      if (data) {
        shop_id = data.merchantData.handle
      }

      return shop_id
    }

    get91appMerchantId(){
      let shop_id = ''

      if (window.nineyi) {
        shop_id = window.nineyi.shopId
      }

      return shop_id
    }

    async getCybMerchantId(){
      
      let id = ''

      for (let idx = 0; idx < 5; idx++) {
        const scriptSrc = document.querySelector('script[src*="//cdn.cybassets.com/s/files/"]')?.getAttribute('src')
        if (scriptSrc) {
          const match = scriptSrc.match(/\/s\/files\/(\d+)\//);
          if (match && match.length > 1) {
            id  = match[1];
          } else {
            id = ''
          }
        }

        if (id) {
          break
        }
        
        try {
          let cb = ga.getByName('cyberbiz')
          id = cb.model.data.ea[':dimension1']
          if (id) {
            break
          }
          else {
            this.sleep(1000)
          }
        } catch (error) {
          this.sleep(1000)
        }
      }

      return id
    }

    loadCSS(href) {
      return new Promise((resolve, reject) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.onload = () => resolve('CSS 加載完成');
        link.onerror = () => reject('CSS 加載失敗');
        document.body.appendChild(link);
      });
    }

    loadJS(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => resolve('JS 加載完成');
        script.onerror = () => reject('JS 加載失敗');
        document.body.appendChild(script);
      });
    }

    copyAttributes(sourceElement, targetElement) {
      // 獲取來源元素的所有屬性
      const attributes = sourceElement.attributes;
    
      // 將每個屬性複製到目標元素
      for (let i = 0; i < attributes.length; i++) {
        const attr = attributes[i];
        targetElement.setAttribute(attr.name, attr.value);
      }
    }
    
    removeAllAttributes(element) {
      // 獲取元素的所有屬性
      const attributes = element.attributes;
    
      // 將所有屬性逐一移除
      while (attributes.length > 0) {
        element.removeAttribute(attributes[0].name);
      }
    }
    unique(el){
      const dynamicIdPattern = /^[A-Z]{8}$/;
      const otherPatterns = [
        'lazy', 'loaded', 'cached', 'cache', 'temp',
        'transient', 'dynamic', 'animated',
        'ng-scope', 'ng-hide', 'tabset-tab-', 'active', "#", "."
      ];
      const combinedRegex = new RegExp(
        `${dynamicIdPattern.source}|${otherPatterns.join('|')}`, 'i'
      );

      const options = {
          // Array of selector types based on which the unique selector will generate
          selectorTypes: ['ID', 'Class', 'Tag', 'NthChild'],
          excludeRegex: combinedRegex
      }
      return unique(el, options) 
    }
  }